import { useEffect } from 'react';
import { sso } from '../../../auth/sso';
import { TitledCircularProgress } from '../../Feedback/TitledCircularProgress/TitledCircularProgress';

export function SignOut() {
  useEffect(() => {
    // Clear the local session first and unconditionally, then redirect to the auth
    // site's logout to revoke the shared session. A blocked redirect still leaves this
    // tab signed out.
    sso.logout();
  }, []);

  return <TitledCircularProgress title="Signing out…" />;
}
